require('./bootstrap');
require('bootstrap');
require('bootstrap-modal');
require('bootstrap-datepicker');
require('pc-bootstrap4-datetimepicker');
require('datatables.net-bs4');
require('jquery-mask-plugin');
import Alpine from 'alpinejs'
import focus from '@alpinejs/focus'
window.Alpine = Alpine;
window.Alpine.plugin(focus);

global.$ = global.jQuery = require('jquery');
window.Dropzone = require('dropzone');
window.Compressor = require('compressorjs');
Dropzone.autoDiscover = false;

import money from "./money";
import masks from "./masks";

import manage_time from "./manage_time";
import product from "./product";
import customer from "./customer";
import order from "./order";
import category from "./category";
import modifier from "./modifier";
import time_station from "./time_station";
import auth from "./auth";
import dashboard from "./dashboard";
import pager from "./pager";
import pos from "./pos";
import table from "./table";
import cash from "./cash";
import employee from "./employee";
window.Employee = employee;
import errors from "./errors";
import payroll from "./payroll";
import settings from "./settings";
import incidents from './incidents';
import notepad from './notepad';
import admin_users from './admin/admin_users';
import articles from './admin/articles';
import uploads from './admin/uploads';
import users from "./users";
import refund from "./refund";
import services_management from "./organizations/services-management/services_management";
import phone_confirmation from "./phone_confirmation";

import time_management from './admin/time_management';
import email_templates from "./email-templating/email_templates";
import email_otifications from "./email-templating/email-notifications";
import audience from "./email-templating/audience";
import worker_cabinet from "./worker_cabinet";
import vendors from './organizations/vendors-management/vendors';
import video_guides from "./admin/video_guides";
import tasker from "./admin/tasker";
import event from "./admin/event";
import payments from "./payments/payments";
import { SideBar } from "./sidebar";
import service_list from "./services-list/service-list";
import features from "./features";
import price from "./price";
import faq from "./faq";
import { SideBarEvent } from "./Common/Events/Events";
import cockpitStatistics from "./organisations-cockpit/cockpit-statistics";

import paymentSubscriptions from "./payment-subscriptions/payment-subscriptions";
import vehiclesManagement from "./vehicles-mangement/vehicles-management";
import maintenance_report from "./vehicles-mangement/maintenance_report";
import accidents from "./vehicles-mangement/accidents";
import invoices from "./vehicles-mangement/invoices";
import alarms from "./vehicles-mangement/alarms";
import repair_list from "./vehicles-mangement/repair_list";

import activity_logs from "./activity_logs";

import Slider from "./slider";
import snippetSettings from "./snippets/settings";
import RunningLine from "./components/RunningLine";
import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";

import manage_organisations from './admin/manage_organisations';
import LeadsManagement from './organizations/leads-management/leads';
import email_marketing from './admin/email_marketing/email_marketing';
import individualJobs from './jobs-flow/individual-jobs';
window.individualJobs = individualJobs;
import business_page from './business-pages/business_page';
import WorkersSelect from './components/WorkersSelect';
import emailSettings from './organisations-cockpit/email-settings';
import FcmNotify from './fcm-notify';
import createOrganisation from './create-organisation';
import PriceBook from './price-book';
import helpCenter from './static-pages/help-center';
import articlesManagement from './admin/articles-management';
import { ColorPicker } from './components/ColorPicker';

FcmNotify.init();

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {
    money.init();
    window.Alpine.start();

    // Фикс скроллинга для загружаемых с сервера модалок
    new MutationObserver(function() {
        $(`body`).find('.modal').each(function () {
            $(this).off('hidden.bs.modal').on('hidden.bs.modal', () => {
                if ($('.modal.show').length>0) {
                    //console.log(".modal.show length>0");
                    $('body').addClass('modal-open')
                }else{
                    //console.log(".modal.show length<0");
                    $('body').removeClass('modal-open')
                }
            })
        })
    }).observe($(`body`)[0],{childList:true, subtree:true})

    $('[data-target=action-popup]').on('click', () => {
        $('.modal-window-actions').removeClass('d-flex');
        $('.modal-window-actions').addClass('d-none');
        $('[data-action-list-trigger]').removeClass('hover');
    });

    const showDropdownInOpenedSidebar = (dropdownSection, forced=false) => {

        if (dropdownSection.parents('.navbar').first().hasClass('navbar-vertical-right')) {
            const sideBar = $('.navbar-vertical-right').first();

            if (!sideBar.hasClass('opened') && !forced) {
                return;
            }
        } else {
            const sideBar = $('.navbar-vertical-left').first();

            if (!sideBar.hasClass('opened') && !forced) {
                return;
            }
        }
        console.log('next');

        const dropdownBtn = dropdownSection.find('.show-dropdown');
        if (dropdownBtn.hasClass('opened')) {
            dropdownBtn.removeClass('opened');
            dropdownSection.removeClass('opened');
        } else {
            dropdownBtn.addClass('opened');
            dropdownSection.addClass('opened');
        }
        dropdownBtn.parents('li').find('.dropdown').slideToggle();
    }

    const showDropdownInClosedSidebar = (sectionIcon) => {
        const section = sectionIcon.parents('li');
        const dropdown = section.find('.dropdown');
        const sidebar = $('.navbar-vertical-left');
        const mobile_sidebar = $('.navbar-vertical-right');

        if (/* sidebar.hasClass('opened') || */ mobile_sidebar.hasClass('show')) {
            return;
        }

        if (section.hasClass('visible')) {
            section.removeClass('visible');
            dropdown.removeClass('opened');
            sidebar.removeClass('only-dropdown');
        } else {
            section.addClass('visible');
            dropdown.addClass('opened');
            sidebar.addClass('only-dropdown');
        }

        sidebar.find('.dropdown').not(dropdown).removeClass('opened');
        mobile_sidebar.find('.dropdown').not(dropdown).removeClass('opened');
        sidebar.find('li').not(section).removeClass('visible');
        mobile_sidebar.find('li').not(section).removeClass('visible');
    }

    $('.dropdown-section').on('click', function() {
        if ($(this).parents('.navbar').hasClass('navbar-mobile')) {
            showDropdownInOpenedSidebar($(this));
        } else {
            showDropdownInClosedSidebar($(this).find('.icon'));
        }
        if ($(this).parents('li').hasClass('locked')) window.location = '/price';
    });
    $('.dropdown-section .icon').on('click', function() {
        //showDropdownInClosedSidebar($(this));
        if ($(this).parents('li').hasClass('locked')) window.location = '/price';
    });

    $('body').off('click', '.preview-ticket-link')
    .on('click', '.preview-ticket-link' ,function(ev) {
        let ticket = $(ev.currentTarget).attr('data-id');
        $.ajax({
            type: 'POST',
            url: `/admin/ticket-management/incident/${ticket}/preview`,
            success: (response) => {
                $('.preview-ticket-container').html(response);
                $('#ticket-preview-modal').modal('show');
            }
        });
    });

    $('#dropdown-call-menu').on('click', ev=>{
        ev.stopPropagation();
    })

    $('.open-sidebar').on('click', function() {

        const sideBar = $('.navbar-vertical-left').first();
        sideBar.removeClass('only-dropdown');
        if (sideBar.hasClass('opened')) {
            sideBar.removeClass('opened');
            $(this).find('span').text('>>');
            $('.sidebar-head').removeClass('opened');
            $('main').removeClass('compressed');

            for (let dropdownSection of $('.dropdown-section')) {
                dropdownSection = $(dropdownSection);
                const dropdown = dropdownSection.parents('li').find('.dropdown');
                if (dropdown.css('display') != 'none') {
                    showDropdownInOpenedSidebar(dropdownSection, true);
                }
            }
            //$(this).css('transform', 'translateX(0)');
        } else {
            sideBar.addClass('opened');
            $('.sidebar-head').addClass('opened');
            $('main').addClass('compressed');
            $(this).find('span').text('<<');
            //$(this).css('transform', 'translateX(176px)');
        }
        $.ajax({
            method: "POST",
            url: '/menu-visibility',
            success: () => {

            }
        });

        document.querySelector('.top-notifications').dispatchEvent(SideBarEvent);
    });

    $('.top-notifications').on('sidebar', (e) => {
        const topNotifications = $('.top-notifications');
        if (topNotifications.hasClass('compressed')) topNotifications.removeClass('compressed')
        else topNotifications.addClass('compressed');
    });

    $('#select_organisation').on('change', function() {
        $('#permission').val($('#select_organisation option:selected').data('permission'));
    })
    $('body').on('change', '#select_organisation', (e) => {
        if ($(e.currentTarget).val() == window.organisation_id) {
            $('#select-org-btn').attr('disabled', 'disabled');
        }else{
            $('#select-org-btn').removeAttr('disabled');
        }
    });

    $('input#logo_img').change(function () {
        if ($('#logo_img').val() == '') {
            $('#logo_img_label').css('border-color', 'red');
        }else{
            $('#logo_img_label').css({'border-color': ''});

            let directory = 'email-templates';
            let form = $('#upload_logo_img_form')[0];
            let data = new FormData(form);
            data.append('directory', directory);
            $.ajax({
                type: 'POST',
                url: '/email-department/upload-image',
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: function(response) {
                    $('#logo_img_label').text($('#logo_img').val().split('\\').pop());
                    $('#logo_img').attr('value',response)
                    $('#logo-preview').attr('src',location.protocol + "//" + location.host+response)
                    $('#logo-preview-container').removeClass('d-none').addClass('d-flex')
                },
                error: function(response) {
                    $(form).find('.error').html('');
                    if (response.responseJSON.errors.upload_image) {
                        const errors = Object.values(response.responseJSON.errors);
                        errors[0].forEach(element => {
                            $(form).find('.error').removeClass('d-none').append(`<div class="my-2">${element}</div>`);
                        });
                    }
                    setTimeout(() => {
                        $(form).find('.error').addClass('d-none')
                    }, 3000);
                }
            });
        }
    })
    $('input#background_img').change(function() {
        if ($('#background_img').val() == '') {

        } else {
            let directory = 'organisation-background';
            let form = $('#upload_background_img_form')[0];
            let data = new FormData(form);
            data.append('directory', directory);
            $.ajax({
                type: 'POST',
                url: '/email-department/upload-image',
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: function(response) {
                    $('#background_img_label').text($('#background_img').val().split('\\').pop());
                    $('#background_img').attr('value',response)
                    $('#background-preview').attr('src',location.protocol + "//" + location.host+response)
                    $('#background-preview-container').removeClass('d-none').addClass('d-flex')
                },
                error: function(response) {
                    $(form).find('.error').html('');
                    if (response.responseJSON.errors.upload_image) {
                        const errors = Object.values(response.responseJSON.errors);
                        errors[0].forEach(element => {
                            $(form).find('.error').removeClass('d-none').append(`<div class="my-2">${element}</div>`);
                        });
                    }
                    setTimeout(() => {
                        $(form).find('.error').addClass('d-none')
                    }, 3000);
                }
            });
        }
    });

    $('#delete-logo').off('click').on('click', (e)=>{
        let data = new FormData();
        data.append('directory', 'email-templates');
        $.ajax({
            type: 'POST',
            url: '/email-department/delete-image',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            success: function(response) {
                if(response.success){
                    $('#logo_img').attr('value','')
                    $('#logo-preview').attr('src','')
                    $('#logo-preview-container').removeClass('d-flex').addClass('d-none')
                    $('#logo_img_label').text('Select image')
                }
            },
            error: function(resp) {
                console.log(response);
                $('.error-log').text(resp.responseJSON.message);
            }
        });
    })
    $('#delete-background').off('click').on('click',(e)=>{
        let data = new FormData();
        data.append('directory', 'organisation-background');
        $.ajax({
            type: 'POST',
            url: '/email-department/delete-image',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            success: function(response) {
                if(response.success){
                    $('#background_img').attr('value','')
                    $('#background-preview').attr('src','')
                    $('#background-preview-container').removeClass('d-flex').addClass('d-none')
                    $('#background_img_label').text('Select image')
                }
            },
            error: function(resp) {
                console.log(response);
                $('.error-log').text(resp.responseJSON.message);
            }
        });
    })

    $('.apply-code-btn').click(function (e) {
        e.preventDefault();
        $.ajax({
            method: 'POST',
            url: '/apply-code',
            data: {
                promo_code: $('#promo_code').val(),
            },
            success: (response) => {
                if (response.error) {
                    $('.error-container').find('.error-text').text(response.error);
                    $('.error-container').removeClass('d-none');
                }else if(response.message){
                    $('.error-container').addClass('d-none');
                    $('.form-container').html(`<p class="text-center">${response.message}</p>`);
                }
            }
        });
    });

    $('#promo_code').on('input', function(e) {
        let submitButton = $(this).parents('form').find("button[type='submit']");
        /* if ($(this).val().length==3 && $(this).val() == "BB-") {

            $('#promo_code').inputmask('remove').inputmask({
                mask: "*{1,80}",
                greedy: false,
                definitions: {
                    '*': {
                      validator: "[0-9A-Za-z_\-]",
                      casing: "upper"
                    }
                }
            });
            } else if($(this).val().length==3 && $(this).val() !== "BB-") {

            $('#promo_code').inputmask('remove').inputmask({
                mask: "AAAA-AAAA-AAAA-AAAA",
                greedy: false,
                definitions: {
                    'A': {
                      validator: "[0-9A-Za-z]{0,1}",
                      casing: "upper"
                    }
                },
                placeholder: 'XXXX-XXXX-XXXX-XXXX'
            });
        } */

        if ($(this).val() == "") {
            $(this).removeClass('border-danger');
            $('.code-status').text('');
            submitButton.attr('disabled', false);
        }else{
            $.ajax({
                method: 'POST',
                url: 'admin/promo-codes/check-code',
                data: {
                    name: $(this).val(),
                },
                success: (response) => {
                    if (response == true) {
                        $('.code-status').text('Great! Your Code worked!').css('color', '#E4A947');
                        $(this).removeClass('border-danger').css('border-color', '#E4A947');
                        submitButton.attr('disabled', false);
                    }else{
                        $('.code-status').text('Oops! Code didn\'t match!').css('color', '#DB3A57');
                        $(this).addClass('border-danger');
                        submitButton.attr('disabled', true);
                    }
                },
                error: (response) => {
                    $('.code-status').text('Oops! Code didn\'t match!').css('color', '#DB3A57');
                    $(this).addClass('border-danger');
                    submitButton.attr('disabled', true);
                }
            })
        }
    });


    manage_time.init();
    product.init();
    customer.init();
    order.init();
    category.init();
    modifier.init();
    time_station.init();
    auth.init();
    dashboard.init();
    pager.init();
    pos.init();
    table.init();
    cash.init();
    employee.init();
    errors.init();
    payroll.init();
    settings.init();
    // chat.init();
    incidents.init();
    //demo_incidents.init();
    notepad.init();
    admin_users.init();
    articles.init();
    uploads.init();
    users.init();
    refund.init();
    worker_cabinet.init();
    time_management.init();
    email_templates.init();
    tasker.init();
    event.init();
    services_management.init();
    payments.init();
    email_otifications.init();
    audience.init();
    let serviceList = new service_list();
    features.init();
    price.init();
    faq.init();
    video_guides.init()
    paymentSubscriptions.init();
    cockpitStatistics.init();
    vehiclesManagement.init();
    maintenance_report.init();
    accidents.init();
    invoices.init();
    alarms.init();
    repair_list.init();
    activity_logs.init();
    masks.init();
    Slider.init();
    phone_confirmation.init();
    snippetSettings.init();
    RunningLine.init();
    SimpleSectionSwitcher.init();
    manage_organisations.init();
    email_marketing.init();
    individualJobs.init();
    business_page.init();
    if (location.pathname.includes('/leads')) {
        let leads = new LeadsManagement();
    }
    vendors.init();
    WorkersSelect.init();
    emailSettings.init();
    FcmNotify.init();
    createOrganisation.init();
    PriceBook.init();
    helpCenter.init();
    articlesManagement.init();
    ColorPicker.init();
});

